import {NormalContentBlockModel} from "@/models/api/pharma-cms-content-block/NormalContentBlockModel";
import {
    cloneButtonRestDtoMetaData,
    cloneTextWithImageContentRestDtoMetaData,
    ContentBlockMetadataRestDto,
    SimpleTextWithImageContentRestDto
} from "@/api/pharma-cms-content-block/models";
import {MultilingualRestDtoModel} from "@/models/MultilingualRestDtoModel";
import {StatusEnum} from "@/api/enums/status-enum";
import {ButtonRestDtoModel} from "@/models/api/pharma-cms-content-block/ButtonRestDtoModel";
import {VerticalImageShiftEnum} from "@/api/enums/vertical-image-shift-enum";
import {HorizontalImageShiftEnum} from "@/api/enums/horizontal-image-shift-enum";
import {ButtonHorizontalPositionEnum} from "@/api/enums/button-horizontal-position-enum";

export class SimpleTextWithImageContentRestDtoModel extends NormalContentBlockModel implements SimpleTextWithImageContentRestDto {
    status_code: StatusEnum;
    title?: MultilingualRestDtoModel;
    content: MultilingualRestDtoModel;
    image_key?: MultilingualRestDtoModel;
    vertical_image_shift_code?: VerticalImageShiftEnum | null;
    horizontal_image_shift_code?: HorizontalImageShiftEnum | null;
    button?: ButtonRestDtoModel;
    button_horizontal_position_code?: ButtonHorizontalPositionEnum | null;
    cb_metadata?: ContentBlockMetadataRestDto;

    constructor(status_code: StatusEnum, content: MultilingualRestDtoModel) {
        super();
        this.status_code = status_code;
        this.content = content;
    }

    public static createWithDefaults(): SimpleTextWithImageContentRestDtoModel {
        const model = new this(StatusEnum.PUBLISHED, MultilingualRestDtoModel.createWithDefaults());
        model.title = MultilingualRestDtoModel.createWithDefaults();
        model.image_key = MultilingualRestDtoModel.createWithDefaults();
        model.vertical_image_shift_code = VerticalImageShiftEnum.NO_SHIFT;
        model.horizontal_image_shift_code = HorizontalImageShiftEnum.NO_SHIFT;
        model.button = ButtonRestDtoModel.createWithDefaults();
        model.button_horizontal_position_code = ButtonHorizontalPositionEnum.LEFT;

        return model;
    }

    public static cloneFrom(source: SimpleTextWithImageContentRestDto): SimpleTextWithImageContentRestDtoModel {
        const model = new this(source.status_code, MultilingualRestDtoModel.cloneFrom(source.content));
        model.title = source.title ? MultilingualRestDtoModel.cloneFrom(source.title) : undefined;
        model.image_key = source.image_key ? MultilingualRestDtoModel.cloneFrom(source.image_key) : undefined;
        model.vertical_image_shift_code = source.vertical_image_shift_code;
        model.horizontal_image_shift_code = source.horizontal_image_shift_code;
        model.button = source.button ? ButtonRestDtoModel.cloneFrom(source.button) : undefined;
        model.button_horizontal_position_code = source.button_horizontal_position_code;
        model.cb_metadata = source.cb_metadata ?? undefined;

        return model;
    }

    public cloneMetadataFrom(source: SimpleTextWithImageContentRestDtoModel): void {
        cloneTextWithImageContentRestDtoMetaData(this, source);

        if (this.button && source.button) {
            cloneButtonRestDtoMetaData(this.button, source.button)
        }
    }
}
